export default "__VITE_ASSET__BuxgEwRW__"